/*
 * @Author: your name
 * @Date: 2021-06-04 18:20:13
 * @LastEditTime: 2021-07-01 14:51:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qianyue\src\components\Disease\Disease.js
 */
let reservationMain = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;

    this.GetOrgList = function (la,ln,success, error) {
        var url = ServiceBaseAddress + `/api/Organization/GetAppointmentOrganizationList/${la}/${ln}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetOrgDetial = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/Organization/Detial/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHospitalDept = function (success, error) {
        var url = ServiceBaseAddress + `/api/HospitalDept`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    
    this.GetorgDoctorList = function (id,departmentId,hosTitleIdSearch,selectExpert,selectDateSearch,success, error) {
        var url = ServiceBaseAddress + `/api/User/GetAppointmentDoctorList/${id}/${departmentId}/%20/${hosTitleIdSearch}/${selectExpert}/${selectDateSearch}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    this.GetAvailableScheduleByDoctorDetail = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/DoctorAppointment/GetAvailableScheduleByDoctorId/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }

    this.GetDoctorAppointmentOrder = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/DoctorAppointmentOrder/CreateOrder'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetVerificationSuccessPay = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/VerificationSuccessPay/${orderId}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetUserAppointmentOrderList = function (state,pageIndex, pageSize,success, error) {
        var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/GetUserOrderList/${state}/${pageIndex}/${pageSize}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetUserRefundOrder = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/UserRefundOrder/${orderId}`
        TokenClient.Post(url, false, null,null,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetCancelOrderData = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/CancelOrder/${orderId}`
        TokenClient.Post(url, false, null,null,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetDeleteOrderData = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/DeleteOrder/${orderId}`
        TokenClient.Post(url, false, null,null,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }

    this.GetDoctorSubmitPay = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/DoctorAppointmentOrder/SubmitPay'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }

}

export { reservationMain }